



















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import OpenDataComponent from '@/components/openData.vue';
import moment from 'moment';
import { getNumber } from '@/helpers';

@Component({
  components: {
    OpenDataComponent
  }
})
export default class ProjectEditComponent extends Vue {
  account = this.$store.state.account;
  project = this.$store.state.projectSimple;
  lookup = this.$store.state.lookup;
  startedOnOpen = false;
  endedOnOpen = false;
  grantContractSignDateOpen = false;
  isValid = true;
  requiredRule = [(v: any) => !!v || this.$t('project.error.requiredField')];

  get detail() {
    return this.project.detail;
  }

  getLookup(id: number) {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](id);

    return lookup
      .filter((item: any) => !item.isDisabled)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  created() {
    if (this.project.detail.responsibleFaculty && this.project.detail.responsibleFaculty.id) {
      this.$store.dispatch('account/getSolvers', this.project.detail.responsibleFaculty.id);
    }
  }

  get shareOfInvestmentCostsValidation() {
    const budget = this.project.detail.budget;

    return [(value: string) => value !== '' || this.$t('project.error.requiredField'), (value: string) => getNumber(value) <= budget || this.$t('project.error.shareOfInvestmentCostsValidation')];
  }

  get startedOn() {
    return this.project.detail.startedOn ? moment(this.project.detail.startedOn).format('YYYY-MM-DD') : '';
  }

  set startedOn(date: string) {
    this.project.detail.startedOn = date;
  }

  get endedOn() {
    return this.project.detail.endedOn ? moment(this.project.detail.endedOn).format('YYYY-MM-DD') : '';
  }

  set endedOn(date: string) {
    this.project.detail.endedOn = date;
  }

  get grantContractSignDate() {
    return this.project.detail.grantContractSignDate ? moment(this.project.detail.grantContractSignDate).format('YYYY-MM-DD') : '';
  }

  set grantContractSignDate(date: string) {
    this.project.detail.grantContractSignDate = date;
  }

  get budgetValidation() {
    return [(value: string) => !!getNumber(value) || this.$t('project.error.requiredField')];
  }

  get totalBudgetUniversityValidation() {
    return [
      (value: string) => !!getNumber(value) || this.$t('project.error.requiredField'),
      (value: string) => (getNumber(value) && getNumber(value) <= (this.project.detail.budget || 0)) || this.$t('project.error.totalBudgetUniversityValidation')
    ];
  }

  getFormatedDate(date: Date) {
    return date ? moment(date).format('DD.MM.YYYY') : '';
  }

  handleUpdateSubmit() {
    if ((this.$refs.project as any).validate()) {
      const project = this.project.detail;
      const id = this.$route.params.id;
      if (id) {
        this.$store.dispatch('projectSimple/updateProject', { id, project });
      } else {
        this.$store.dispatch('projectSimple/createProject', { project });
      }
    }
  }

  customSolverFilter(item: any, queryText: string, itemText: string) {
    const userName = item.userName.toLowerCase();
    const firstName = item.firstName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const lastName = item.lastName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const searchText = queryText
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return userName.indexOf(searchText) > -1 || firstName?.indexOf(searchText) > -1 || lastName?.indexOf(searchText) > -1;
  }

  get projectType() {
    return (this.project.detail as any).projectType;
  }

  get facultyId() {
    return (this.project.detail as any).responsibleFaculty.key;
  }

  get startedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.endedOn || moment(value) <= moment(this.endedOn) || this.$t('project.error.startedOn')
    ];
  }

  get endedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.startedOn || moment(value) >= moment(this.startedOn) || this.$t('project.error.endedOn')
    ];
  }

  // @Watch('projectType')
  // onProjectType(value: string, oldValue: string) {
  //   this.project.detail.coordinator = null;
  //   this.project.detail.partners = null;
  //   this.project.detail.grantContractNumber = null;
  //   this.project.detail.grantContractSignDate = '';
  // }

  @Watch('facultyId')
  onFacultyChanged(value: any, oldValue: any) {
    if (value && value !== null) {
      const faculty = this.getLookup(6).find((item: any) => item.key === value);

      if (faculty) {
        this.$store.dispatch('account/getSolvers', faculty.id);
      }
    }
  }
}
